module.exports = __webpack_public_path__ + "img/xgus_vapaeetokens.9542129.png";